var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid';
import { classNames } from '@web/utility';
import { SortOrderEnum } from '@workalizer/shared';
var iconClass = 'h-3 w-3 shrink-0';
var SortIconSlot = function (_a) {
    var active = _a.active, children = _a.children;
    return (_jsx("span", __assign({ className: classNames('inline-flex size-3 items-center justify-center leading-none', active && 'rounded-full bg-gray-100') }, { children: children })));
};
export var TableSortIcons = function (_a) {
    var isActive = _a.isActive, direction = _a.direction;
    var isAscActive = isActive && (direction === SortOrderEnum.ASC || direction === 'asc');
    var isDescActive = isActive && (direction === SortOrderEnum.DESC || direction === 'desc');
    return (_jsxs("span", __assign({ className: "inline-flex flex-col -space-y-1 shrink-0", "aria-hidden": true }, { children: [_jsx(SortIconSlot, __assign({ active: isAscActive }, { children: _jsx(ChevronUpIcon, { className: classNames(iconClass, isAscActive ? 'text-gray-600' : 'text-gray-300') }) })), _jsx(SortIconSlot, __assign({ active: isDescActive }, { children: _jsx(ChevronDownIcon, { className: classNames(iconClass, isDescActive ? 'text-gray-600' : 'text-gray-300') }) }))] })));
};
